import { IconButton, InputAdornment, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Iconify from '../../../../../reusable-components/iconify';
import { formStyle } from '../../TransitionStyles';

TextInput.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
  placeholder: PropTypes.string,
};
export default function TextInput({ fieldName, focusedField, setFocusedField, fieldAttributes, placeholder = '' }) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name: fieldName, control });
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  return (
    <TextField
      inputRef={field.ref}
      key={field.id}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
      onFocus={() => setFocusedField?.(fieldName)}
      inputProps={{
        onBlur: () => setFocusedField?.(null),
      }}
      placeholder={placeholder}
      autoComplete="off"
      fullWidth
      size="small"
      type="text"
      disabled={!fieldAttributes.isEditable || isCanceled}
      value={field.value ?? ''}
      error={!!fieldState.error}
      onChange={(e) => field.onChange(e.target.value)}
      helperText={fieldState.error?.message}
      sx={formStyle}
      InputProps={{
        sx: { background: 'white' },
        endAdornment:
          field.value && focusedField === fieldName ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onMouseDown={(e) => {
                  e.preventDefault();
                  field.onChange('');
                }}
                edge="end"
                tabIndex={-1}
              >
                <Iconify icon="eva:close-outline" />
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
    />
  );
}
